import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Register Chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const TeamDetails = () => {
  // Chart data
  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Efficiency %",
        data: [80, 85, 78, 90],
        backgroundColor: "#22b98e",
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">Team Details</h2>

      {/* Team Overview */}
      <div className="row text-center mb-4">
        <div className="col-md-3">
          <div className="card text-white bg-primary p-3">
            <i className="bi bi-person-badge fs-3"></i>
            <h6 className="mt-2">Lead</h6>
            <p className="mb-0">John Doe</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-success p-3">
            <i className="bi bi-people fs-3"></i>
            <h6 className="mt-2">Members</h6>
            <p className="mb-0">John Doe, Rizwan Ali, Farhan</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-info p-3">
            <i className="bi bi-building fs-3"></i>
            <h6 className="mt-2">Department</h6>
            <p className="mb-0">IT</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-warning p-3">
            <i className="bi bi-clock-history fs-3"></i>
            <h6 className="mt-2">Progress</h6>
            <p className="mb-0">Jan 24 - Now</p>
          </div>
        </div>
      </div>
      <button
  className="btn btn-primary "
  style={{ width: 'auto', textAlign: 'left', paddingLeft: '10px' }}
>
  <i className="bi bi-plus-circle"></i> Add Task
</button>

      {/* Kanban Task Overview and Notifications */}
      <div className="row mt-4">
      <div className="col-md-6">
  <div className=" p-3 mb-2">
    <h4>✅ Task Overview (Kanban)</h4>
    <table className="table table-bordered table-hover">
      <thead>
      
      </thead>
      <tbody>
        <tr>
          <td>Fix Login Bug  <span className="badge bg-danger">Pending</span></td>
        </tr>
        <tr>
          <td>UI Enhancements  <span className="badge bg-warning">In Progress</span></td>
        </tr>
        <tr>
          <td>Database Optimization  <span className="badge bg-success">Completed</span></td>
        </tr>
      </tbody>
    </table>
  </div> 
</div>

<div className="col-md-6">
  <div className=" p-3 mb-2">
    <h4>🔔 Notifications & Alerts</h4>
    <table className="table table-bordered table-hover">
      <thead>
      
      </thead>
      <tbody>
        <tr>
          <td className="text-danger">⚠️ Task "Fix Login Bug" is overdue!</td>
        </tr>
        <tr>
          <td className="text-success">✅ CRM Dashboard project completed!</td>
        </tr>
        <tr>
          <td className="text-primary">📢 Team meeting scheduled for Aug 10.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div></div>

      {/* Key Metrics & Efficiency Chart */}
      <div className="row mb-4">
        <div className="col-md-6">
          <div className="card p-3">
            <h5 className="text-center">
              <i className="bi bi-bar-chart"></i> Key Metrics
            </h5>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                Ongoing Projects: <span className="badge bg-primary">3</span>
              </li>
              <li className="list-group-item">
                Completed Projects: <span className="badge bg-success">12</span>
              </li>
              <li className="list-group-item">
                Average Task Completion Rate:{" "}
                <span className="badge bg-warning">85%</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card p-3">
            <h5>Team Efficiency</h5>
            <div style={{ width: "100%", height: "300px" }}>
              <Bar data={data} options={options} />
            </div>
          </div>
        </div>
      </div>

      {/* Team Chat Section */}
      <div className="card p-3 mb-4">
        <h5>Team Discussion</h5>
        <textarea className="form-control" rows="3" placeholder="Write a message..."></textarea>
        <button className="btn btn-primary mt-2">Send</button>
      </div>

      {/* Back to Dashboard Button */}
      <a href="/teams" className="btn btn-secondary">
        Back to Teams Dashboard
      </a>
    </div>
  );
};

export default TeamDetails;
